import employees from './employees/tr';
import dataTable from './dataTable/tr';
import customers from './customers/tr';
import login from './login/tr';
import projectManagement from './projectManagement/tr';
import profilePage from './profilePage/tr';
import visitModal from './visitModal/tr';
import cargo from './cargo/tr';
import operations from './operations/tr';
import quality from './quality/tr';
import smoLead from './smoLead/tr';
import regionReports from './regionReports/tr';
import loginReminders from './loginReminders/tr';
import leaves from './leaves/tr';
import stock from './stock/tr';
import tariffs from './tariffs/tr';
import centers from './centers/tr';
import budget from './budget/tr';
import userGuide from './userGuide/tr';
import errorReports from './errorReports/tr';
import belgeKontrol from './belgeKontrol/tr';
import pageAccess from './pageAccess/tr';
import todo from './todo/tr';
import insurance from './insurance/tr';
import educationReports from './educationReports/tr';
import bankAccounts from './bankAccounts/tr';
import employeeFinance from './employeeFinance/tr';
import salaryPayment from './salaryPayment/tr';
import projectFinance from './projectFinance/tr';
import fieldExpenses from './fieldExpenses/tr';
import externalPersonnel from './externalPersonnel/tr';
import employeeReports from './employeeReports/tr';
import employeeAnalysis from './employeeAnalysis/tr';
import dataEntryValues from './dataEntryValues/tr';

// Türkçe metinler. Menü başlıkları için ayrı bir sözlük gerekmez:
// tMenu() Türkçe'de components/shell/menuConfig.js'deki başlıkları kullanır.
const tr = {
  common: {
    close: 'Kapat',
    user: 'Kullanıcı',
    view: 'Görüntüle',
    active: 'Aktif',
    passive: 'Pasif',
    all: 'Tümü',
    retry: 'Tekrar Dene',
    clearSearch: 'Aramayı temizle',
    greeting: {
      morning: 'Günaydın',
      afternoon: 'İyi günler',
      evening: 'İyi akşamlar',
      night: 'İyi geceler',
    },
  },
  language: {
    label: 'Dil',
  },
  shell: {
    mainMenu: 'Ana menü',
    openMenu: 'Menüyü aç',
    closeMenu: 'Menüyü kapat',
    expandMenu: 'Menüyü genişlet',
    collapseMenu: 'Menüyü daralt',
    portal: 'Portal',
    hall: 'Hall — sistem seçimi',
    home: 'Ana Sayfa',
    signOut: 'Çıkış Yap',
    signingOut: 'Çıkılıyor…',
    submenuOf: '{{title}} alt menüsü',
    pendingLeaves: '{{count}} bekleyen izin talebi',
    themeLight: 'Açık tema',
    themeDark: 'Koyu tema',
    switchToLight: 'Açık temaya geç',
    switchToDark: 'Koyu temaya geç',
    account: 'Hesap menüsü',
    profile: 'Profil',
  },
  topbar: {
    search: {
      placeholder: 'Menülerde ara…',
      noResults: 'Sonuç bulunamadı',
      open: 'Menülerde ara',
      close: 'Aramayı kapat',
    },
    tasks: 'Görevlerim',
    newTasks: '{{count}} yeni görev',
    unreadMessages: 'Okunmamış mesajlar',
    pendingLeaves: 'Bekleyen izin talepleri',
  },
  missedCalls: {
    button: 'Cevapsız aramalar',
    title: 'Cevapsız Aramalar',
    markAllRead: 'Tümünü okundu işaretle',
    missedVoice: 'Cevapsız sesli arama',
    missedVideo: 'Cevapsız görüntülü arama',
    callBackVoice: 'Sesli geri ara',
    callBackVideo: 'Görüntülü geri ara',
    markRead: 'Okundu işaretle',
  },
  dashboard: {
    subtitle: 'Şirket portalına hoş geldiniz. Buradan işlemlerinizi gerçekleştirebilir ve bilgilerinize erişebilirsiniz.',
    tasks: {
      title: 'Yapılacaklar Listesi',
      newBadge: '{{count}} Yeni',
      unseen: 'Size atanmış {{count}} yeni göreviniz var. Hemen göz atın.',
      calm: 'Size atanan görevleri görüntüleyin ve takip edin.',
    },
    quickLinks: 'Hızlı erişim',
    links: {
      calendar: { title: 'Takvimim', description: 'Görevlerinizi görüntüleyin ve yönetin.' },
      projects: { title: 'Projelerim', description: 'Projelerinizi takip edin ve güncelleyin.' },
      announcements: { title: 'Duyurular', description: 'Şirket duyurularını takip edin.' },
      manual: { title: 'Kullanım Kılavuzu (Eski Sistem)', description: 'Eski portalın PDF kılavuzu.' },
    },
  },
  tasks: {
    title: 'Görevlerim',
    subtitle: '{{count}} açık görev',
    stats: {
      pending: 'Bekleyen',
      inProgress: 'Devam Eden',
      completed: 'Tamamlanan',
      overdue: 'Gecikmiş',
    },
    filters: {
      active: 'Aktif',
      completed: 'Tamamlanan',
      all: 'Tümü',
    },
    loading: 'Görevler yükleniyor…',
    emptyActive: 'Aktif göreviniz bulunmuyor',
    empty: 'Görev bulunamadı',
    newBadge: 'Yeni',
    overdue: 'Gecikmiş',
    assignees: 'Atananlar',
    changeStatus: 'Durumu değiştir',
    status: {
      pending: 'Beklemede',
      'in-progress': 'Devam Ediyor',
      completed: 'Tamamlandı',
      cancelled: 'İptal Edildi',
    },
    priority: {
      high: 'Yüksek',
      medium: 'Orta',
      low: 'Düşük',
    },
  },
  projects: {
    title: 'Projeler',
    assignedOnly: 'Atanan Projeler',
    allProjects: 'Tüm Projeler',
    showAll: 'Tüm projeleri göster',
    showAssigned: 'Sadece atanan projeleri göster',
    export: 'Rapor Çıktısı',
    exporting: 'Hazırlanıyor…',
    searchPlaceholder: 'Proje kodu, protokol, proje adı, müşteri, merkez veya rol ara…',
    assignmentStatus: 'Görev Durumu',
    projectStatus: 'Proje Durumu',
    count: '{{count}} proje',
    columns: {
      code: 'Proje Kodu',
      protocol: 'Protokol Numarası',
      date: 'Proje Tarihi',
      name: 'Proje Adı',
      assignment: 'Görev Durumu',
      status: 'Proje Durumu',
      fte: 'FTE',
      action: 'İşlem',
    },
    loading: 'Projeler yükleniyor…',
    emptyAssigned: 'Bu çalışana atanmış proje bulunmamaktadır.',
    emptyAll: 'Hiç proje bulunmamaktadır.',
    emptyFiltered: 'Arama ve filtre kriterlerine uyan proje bulunamadı.',
    unassigned: 'Atanmamış',
    hourly: 'Saatlik',
    detail: 'Detay',
    toast: {
      loadError: 'Projeler yüklenirken bir hata oluştu!',
      nothingToExport: 'Dışa aktarılacak proje bulunmamaktadır.',
      exportSuccess: 'Rapor başarıyla oluşturuldu!',
      exportError: 'Rapor oluşturulurken bir hata oluştu!',
    },
  },
  projectDetail: {
    fallbackTitle: 'Proje Detayı',
    protocol: 'Protokol Numarası',
    customer: 'Müşteri',
    startDate: 'Proje Tarihi',
    endDate: 'Proje Bitiş Tarihi',
    projectStatus: 'Proje Durumu',
    assignmentStatus: 'Görev Durumu',
    centersTitle: 'Merkezler ve Görevler',
    noCenters: 'Bu çalışan için merkez bazlı görev kaydı bulunmamaktadır.',
    columns: {
      center: 'Merkez',
      role: 'Rol',
      workerType: 'Çalışan Tipi',
      blinding: 'Körleme',
      assignedAt: 'Atanma Tarihi',
      rate: 'Ücret',
      status: 'Durum',
    },
    unspecified: 'Belirtilmemiş',
    summaryTitle: 'Hasta ve Ziyaret Özeti',
    summaryHint: 'Yalnızca bu çalışanın kayıtları',
    loadingSummary: 'Özet yükleniyor…',
    summaryError: 'Proje özeti yüklenirken bir hata oluştu.',
    patients: 'Çalışanın Hastası',
    homeVisitPatients: 'Ev Ziyaretli Hasta',
    visits: 'Çalışanın Ziyareti',
    patientStatus: {
      planned: 'Planlanan',
      screened: 'Screen Edilen',
      screenFail: 'Screen Fail',
      enrolled: 'Dahil Edilen',
      active: 'Aktif',
      onMedication: 'İlaç Alan',
      completed: 'Tamamlanan',
      withdrawn: 'Çekilen',
    },
  },
  welcome: {
    badge: 'Aramıza Hoş Geldiniz',
    greeting: 'Merhaba, {{name}}!',
    greetingNoName: 'Merhaba!',
    intro: 'HabcareCRO Yönetim Portalı’na ilk girişinizi yaptınız. Bu portal üzerinden görevlerinizi, projelerinizi, izinlerinizi ve özlük bilgilerinizi tek bir yerden yönetebilirsiniz.',
    steps: {
      profile: {
        title: 'Profilinizi Tamamlayın',
        description: 'İletişim bilgilerinizi ve özgeçmişinizi güncelleyerek profilinizi eksiksiz hale getirin.',
      },
      tasks: {
        title: 'Görevlerinizi Takip Edin',
        description: 'Size atanan görevleri "Yapılacaklar Listesi" üzerinden görüntüleyin ve durumlarını güncelleyin.',
      },
      calendar: {
        title: 'Takvim ve Projeler',
        description: 'Takviminizden planlarınızı, "Projelerim" bölümünden görev aldığınız projeleri takip edin.',
      },
      security: {
        title: 'Hesabınızı Güvende Tutun',
        description: 'Size e-posta ile iletilen geçici şifrenizi ilk fırsatta değiştirmenizi öneririz.',
      },
    },
    footer: 'Herhangi bir sorunuz olursa İnsan Kaynakları ekibimiz size yardımcı olmaktan memnuniyet duyar. Başarılar dileriz!',
    manual: 'Kullanım Kılavuzu',
    start: 'Hadi Başlayalım',
  },
  manual: {
    title: 'Kullanım Kılavuzu (Eski Sistem)',
    loading: 'Kılavuz yükleniyor…',
    error: 'PDF yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
    languageNote: '',
    openInNewTab: 'Yeni sekmede aç',
  },
  underConstruction: {
    badge: 'Geliştirme aşamasında',
    title: 'Bu sayfa geliştirilmektedir',
    text: 'Ekibimiz bu sayfa üzerinde çalışıyor. Hazır olduğunda burada olacak; o zamana kadar diğer sayfaları kullanmaya devam edebilirsiniz.',
    progress: 'Geliştirme sürüyor',
    steps: { design: 'Tasarım', build: 'Geliştirme', test: 'Test' },
    address: 'İstenen adres:',
    back: 'Geri Dön',
    home: 'Ana Sayfaya Dön',
  },
  employees,
  dataTable,
  customers,
  login,
  projectManagement,
  profilePage,
  visitModal,
  cargo,
  operations,
  quality,
  smoLead,
  regionReports,
  loginReminders,
  leaves,
  stock,
  tariffs,
  centers,
  budget,
  userGuide,
  errorReports,
  belgeKontrol,
  pageAccess,
  todo,
  insurance,
  educationReports,
  bankAccounts,
  employeeFinance,
  salaryPayment,
  projectFinance,
  fieldExpenses,
  externalPersonnel,
  employeeReports,
  employeeAnalysis,
  dataEntryValues,
};

export default tr;
